export const defaultDateFormat = "MM/DD/YYYY";
export const defaultDateTimeFormat = "MM/DD/YYYY HH:mm:ss:SSS";
export const defaultTimeFormat = "HH:mm:ss:SSS";


// WEBPACK FOOTER //
// ./src/core/constants/defaultValues.js